<script setup lang="ts">
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'GameItemsPreview',

    data() {
        return {
        }
    },
})
</script>

<template>
    <div class="items">
        <img class="item hull_1" :src="`/img/items/hull/bo/warrior/side.png`">
<!--        <img class="item generator_1" :src="`/img/items/generator/7.png`">-->
<!--        <img class="item generator_2" :src="`/img/items/probe/3.png`">-->
        <img class="item probe_1" :src="`/img/items/probe/3.png`">
        <img class="item droid_1" :src="`/img/items/droid/6.png`">
<!--        <img class="item weapon_1" :src="`/img/items/weapon/20_0.png`">-->
    </div>
</template>

<style scoped lang="scss">
.items {
    position: relative;
    min-width: 400px;
    max-width: 400px;
    height: 320px;
}

img {
    position: absolute;
}

.hull_1 {
    width: 400px;
    height: 400px;
    top: -55px;
}

.generator_1 {
    width: 160px;
    top: 170px;
}

.droid_1 {
    width: 142px;
    top: -15px;
    left: 270px;
}


.generator_2 {
    width: 160px;
    left: 115px;
    top: 200px;
}

.probe_1 {
    width: 160px;
    left: 5px;
    top: 170px;
}

.weapon_1 {
    width: 180px;
    top: 200px;
    left: 200px;
    transform: scaleX(-1);
}

</style>
